// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title___--Oh","content":"styles_content__1sIBp","intro":"styles_intro__2oT4U"};